module.exports = __webpack_public_path__ + "static/media/svn.8f635f1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/svn.png
// module id = 200
// module chunks = 0